(() => {
  if (window.mmtHotjarScheduled) return;
  window.mmtHotjarScheduled = true;
  let started = false;
  let timer;
  const events = ['pointerdown', 'keydown', 'scroll'];
  function start() {
    if (started) return;
    started = true;
    clearTimeout(timer);
    events.forEach(type => window.removeEventListener(type, start));
    window._hjSettings = { hjid: 1881455, hjsv: 6 };
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://static.hotjar.com/c/hotjar-1881455.js?sv=6';
    document.head.appendChild(script);
  }
  events.forEach(type => window.addEventListener(type, start, { once: true, passive: true }));
  function schedule() {
    if (!started) timer = window.setTimeout(start, 10000);
  }
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
